export class ContactType
{
    code: number;
    description: string;
}
